// @flow
import {Image, Platform, StyleSheet, View} from 'react-native';
import {ActivityIndicator, Text} from 'trpc-react-native-ui';
import React, {Component} from 'react';

import {
  Checkbox,
  FullButton,
  GradientPage,
  Icon,
} from '../../../components/common';
import DoItLater from '../../../components/payments/DoItLater';
import I18n from '../../../lib/i18n';
import {PageTitle} from '../../../components/signUp';
import config from '../../../config';
import theme from '../../../theme-config';
import * as Navigation from '../../../lib/navigation.js';
import WizzeeLog from '../../../lib/wizzeeLog';

type State = {
  checkboxValue: boolean,
};

class RegisterPaymentDetails extends Component<Props, State> {
  styles = getStyles();

  state = {
    checkboxValue: false,
  };

  shouldVerifyOrderConsistency =
    this.props.route.params?.shouldVerifyOrderConsistency;

  componentDidMount() {
    if (this.shouldVerifyOrderConsistency) {
      this.props.signUpCheckOrderConsistency();
    }
  }

  goToNextPage = () => {
    if (!this.props.isCheckOrderConsistencyLoading) {
      if (this.shouldVerifyOrderConsistency && !this.props.isOrderOk) {
        this.goToRequiredToSignup();
      } else {
        const {route, eSimSelected} = this.props;

        const {redirectTo, bringBackTo, isPaymentMeanUpdate} =
          route.params || {};

        WizzeeLog.log('>>> goToNexPage() - eSimSelected: ', eSimSelected);
        if (redirectTo === 'newPaymentMean') {
          Navigation.navigate(redirectTo, {
            bringBackTo,
            isPaymentMeanUpdate,
            noMargin: false,
          });
        } else {
          eSimSelected || this.props.isActivating
            ? this.props.navigation.navigate('paymentDuringActivate')
            : this.props.navigation.navigate('payment');
        }
      }
    }
  };

  goToRequiredToSignup = () => {
    this.props.navigation.navigate('RedirectToIdentityRequirementOrDashboard');
  };
  displayImage = () =>
    theme.creditCardImage ? (
      <View style={this.styles.imageContainer}>
        <Image style={this.styles.image} source={theme.creditCardImage} />
      </View>
    ) : (
      <Icon
        name="credit-card"
        size={129}
        color={theme.signUpTextColor}
        style={this.styles.creditCard}
      />
    );

  dispayButton = () =>
    this.props.isConfirmLoading ? (
      <ActivityIndicator color={theme.primaryColor} />
    ) : (
      <View style={this.styles.buttonContainer}>
        <FullButton
          text={I18n.t('SignUp.RegisterPaymentDetails.register')}
          onPress={this.goToNextPage}
          isLoading={this.props.isLoading}
          disabled={
            config.displayCheckboxOnRegisterPaymentmean &&
            !this.state.checkboxValue
          }
          testID={'registerPaymentDetailsButton'}
        />
        {this.props.canSkipPayment && (
          <DoItLater style={this.styles.doItLater} />
        )}
      </View>
    );

  displayInformation = () =>
    config.displayCheckboxOnRegisterPaymentmean ? (
      <Checkbox
        labelStyle={{...this.styles.message, ...this.styles.checkbox}}
        onPress={() =>
          this.setState({checkboxValue: !this.state.checkboxValue})
        }
        isChecked={this.state.checkboxValue}
        text={I18n.t('SignUp.RegisterPaymentDetails.checkboxSecurityMessage')}
        lightColors
        testID={'registerPaymentDetailsInfoCheckbox'}
      />
    ) : (
      <Text style={[this.styles.message, this.styles.securityMessage]}>
        {I18n.t('SignUp.RegisterPaymentDetails.securityMessage')}
      </Text>
    );

  render() {
    const styles = this.styles;

    return (
      <GradientPage maxWidth={600} iosEdges={['top','bottom']}>
        <PageTitle
          title={I18n.t('SignUp.RegisterPaymentDetails.title')}
          style={styles.title}
        />
        <View style={styles.container}>
          <Text style={[styles.message, styles.registerMessage]}>
            {I18n.t('SignUp.RegisterPaymentDetails.registerMessage')}
          </Text>
          {this.displayImage()}
          {this.displayInformation()}
          {this.dispayButton()}
          {this.props.hasUnauthenticatedPayment && (
            <Text style={styles.authentRequiredInfo}>
              {I18n.t('SignUp.RegisterPaymentDetails.authentRequiredInfo')}
            </Text>
          )}
        </View>
      </GradientPage>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    authentRequiredInfo: {
      color: theme.errorColor,
      fontSize: 16,
    },
    container: {
      flex: 1,
      justifyContent: 'space-around',
      marginHorizontal: 29,
    },
    checkbox: {
      fontSize: 13,
    },
    creditCard: {
      alignSelf: 'center',
      backgroundColor: 'transparent',
    },
    doItLater: {
      marginTop: 10,
    },
    image: {
      alignSelf: 'center',
      height: Platform.OS === 'web' ? 210 : 150,
      resizeMode: 'cover',
      width: Platform.OS === 'web' ? 210 : 150,
      marginVertical: Platform.OS === 'web' ? 40 : 0,
    },
    imageContainer: {
      alignItems: 'center',
      height: Platform.OS === 'web' ? 100 : 50,
      justifyContent: 'center',
      marginVertical: Platform.OS === 'web' ? 40 : 0,
    },
    message: {
      textAlign: 'left',
      marginVertical: Platform.OS === 'web' ? 20 : 0,
    },
    registerMessage: {
      fontSize: 16,
    },
    securityMessage: {
      fontSize: 13,
    },
    title: {
      marginHorizontal: 35,
      fontSize: Platform.OS === 'ios' ? 20 : 22,
    },
    buttonContainer: {
      marginTop: Platform.OS === 'web' ? 40 : 0,
    }
  });

type Props = {
  canSkipPayment: boolean,
  hasPaymentMean: boolean,
  hasUnauthenticatedPayment: boolean,
  isActivating: boolean,
  isCheckOrderConsistencyLoading: boolean,
  isConfirmLoading: boolean,
  isLoading: boolean,
  isOrderingReplacementSim: boolean,
  isOrderOk: boolean,
  route: NavigationScreenProp<NavigationRoute>,
  refreshPaymentDetails: Function,
  signUpCheckOrderConsistency: Function,
  eSimSelected: boolean,
};

export default RegisterPaymentDetails;
